export default __webpack_public_path__ + "static/newbanner-9cc1623030847f98686784216d40a632.jpg";